export enum InquiryType {
    WIDGET = 'WIDGET',
    PHONE = 'PHONE',
    VISIT = 'VISIT',
}
